import React, { useState } from 'react';
import { Button, Card, Flex, Heading, Text } from 'rebass';
import PayersDropDown from '../../../../components/bridge/PayersDropDown';

const NoOptionMessage = ({ bypassInsurance, wizard }) => {
  return (
    <div style={{ padding: '12px 24px' }}>
      <Text textAlign="left" mb={2} fontSize="16px" fontWeight="400">
        Sorry, we don't recognize this insurance
      </Text>
      <Text textAlign="left" mb={2} fontSize="16px" fontWeight="400">
        1) Check your spelling
        <br />
        2) Check for abbreviations
        <br />
        3) Your insurance is not supported
      </Text>
      <Text textAlign="left" mb={2} fontSize="16px" fontWeight="400">
        Insurance is not required to see a doctor.
        <br />
        You can add your insurance details later.
      </Text>
      <Text textAlign="center" mb={1} fontSize="18px" style={{ cursor: 'pointer' }} onClick={() => bypassInsurance(wizard)}>
        <span style={{ color: '#364f79' }}>Continue</span>
        <span style={{ color: '#f9a394', fontWeight: '600' }}>{' >'}</span>
      </Text>
    </div>
  );
};

export const BridgeInsuranceListSelector = ({ onContinue, onContinueNoInsurance, hasInsurance }) => {
  const [selectedPayer, setSelectedPayer] = useState();
  return (
    <Card p={4} mb={5}>
      <Flex mb={4} flexDirection="column">
        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
          <Heading textAlign="center" mb={4}>
            {!hasInsurance ? 'Check Your Coverage — Now Expanded!' : 'Replace Your Insurance Information'}
          </Heading>
          <Text textAlign="center" mb={4} fontSize="18px">
            We're now in-network with 100+ insurance plans nationwide. See if yours is covered. You may pay as little as $0 with insurance.
          </Text>
        </Flex>
        <div style={{ maxWidth: '500px', alignSelf: 'center', width: '100%' }}>
          <PayersDropDown
            selectedPayer={selectedPayer}
            onPayerChange={(pyr) => {
              setSelectedPayer(pyr);
            }}
          />
        </div>
        <Text textAlign="left" mb={4} fontSize="14px" fontWeight={200} color="#7c7c7c" style={{ maxWidth: '500px', alignSelf: 'center', width: '100%' }}>
          e.g. Aetna, United Healthcare
        </Text>
        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
          <Button
            variant="pink"
            width={[1 / 2, 1 / 3]}
            type="submit"
            disabled={!selectedPayer}
            onClick={() => {
              onContinue(selectedPayer);
            }}
          >
            Check Coverage
          </Button>
        </Flex>
        <div
          style={{
            height: '1px',
            backgroundColor: '#ccc',
            margin: '40px -32px',
          }}
        />
        <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column" textAlign="center">
          <Text
            textAlign="center"
            mb={1}
            fontSize="18px"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              onContinueNoInsurance();
            }}
          >
            <span style={{ color: '#364f79' }}>Skip Insurance</span>
            <span style={{ color: '#f9a394', fontWeight: '600' }}>{' >'}</span>
          </Text>
          <Text textAlign="center" fontSize="16px" fontWeight={200} color="#7c7c7c">
            Insurance is not required to see a doctor.
            <br />
            You can add your insurance details later.
          </Text>
        </Flex>
      </Flex>
    </Card>
  );
};
